import axios from 'axios';
import router from '../router/index';
import $ from 'jquery';
import Vue from 'vue';
import { Message } from 'element-ui';

const files = {
    state: () => ({
        items: [],
    }),
    mutations: {
        setDocumentCategoryList(state, payload) {
            state.items = payload;
        },
    },
    actions: {
        async getDocumentCategoryList(store) {
            var res = await axios.post('document/categorylist', { skip: 0, take: 1000 });
            var categories = res.data.data.items;
            var res2 = await store.dispatch('getDocumentList');
            var items = res2.data.data.items;
            categories.map((i, index) => {
                categories[index].files = items.filter((k) => k.categoryID == i.id);
            });
            store.commit('setDocumentCategoryList', categories);
        },
        async getDocumentList() {
            var res = await axios.post('document/list', { skip: 0, take: 1000 });
            return res;
        },
        async updateDocumentSorting(store, payload) {
            var res = await axios.post('document/updatesorting', { items: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
        async documentCategoryAddUpdate(store, payload) {
            var res = await axios.post('document/categoryaddorupdate', payload);
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
        async documentFileAddUpdate(store, payload) {
            var res = await axios.post('document/addorupdate', payload);
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
        async getDocument(store, payload) {
            var res = await axios.post('document/categoryget', { id: payload });
            return res;
        },
        async getDocumentFile(store, payload) {
            var res = await axios.post('document/get', { id: payload });
            return res;
        },
        async documentDelete(store, payload) {
            var res = await axios.post('document/categorydelete', { id: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
        async documentFileDelete(store, payload) {
            var res = await axios.post('document/delete', { id: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
    },
    getters: {},
};

export default files;


// WEBPACK FOOTER //
// ./src/store/files.js